<template>
  <div class="kye-preview-file-item">
    <slot name="previewFileItem" :fileName="fileName" :url="url" :extendName="extendName">
      <div class="kye-preview-file-item-info" @click="preview" :class="nameClass">
        <img class="kye-preview-file-item-info-img" :src="fileImg" alt="" />

        <el-tooltip popper-class="kye-dark" :content="name" placement="top">
          <span class="kye-preview-file-item-info-name">{{ name }}</span>
        </el-tooltip>
        <!-- <i class="el-icon-document"></i> -->
        <!-- {{fileName || '无文件名'}} -->
      </div>
      <div class="kye-preview-file-item-tools">
        <div class="kye-preview-file-item-tools-icon is-download" v-if="canDownload">
          <img src="./images/download.png" alt="" @click.stop="download" />
        </div>
        <div class="kye-preview-file-item-tools-icon is-remove" v-if="canRemove">
          <img src="./images/close.png" alt="" @click.stop="remove" />
        </div>
        <!-- <span class="kye-preview-file-item-tools-preview" @click="preview" v-if="canPreview">预览</span>
        <i v-if="canRemove" class="el-icon-close kye-preview-file-item-tools-close" @click="remove"></i> -->
      </div>
    </slot>
  </div>
</template>
<script>
import { getImgSuffix, getExtendName } from './utils'

export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    extendName: {
      type: String,
      default: ''
    },
    canDownload: {
      type: Boolean,
      default: true
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    canPreview: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  computed: {
    name () {
      return this.fileName || '无文件名'
    },
    nameClass () {
      return {
        'is-preview': this.canPreview
      }
    },
    fileImg () {
      const { fileName, extendName } = this
      const imgType = extendName || getExtendName(fileName)
      return getImgSuffix(imgType)
    }
  },
  methods: {
    // 预览
    preview () {
      if (!this.canPreview) {
        return
      }
      this.$emit('preview', {
        url: this.url,
        fileName: this.fileName,
        extendName: this.extendName,
        id: this.id
      })
    },
    // 下载
    download () {
      if (!this.canDownload) {
        return
      }
      this.$emit('download', {
        url: this.url,
        fileName: this.fileName,
        extendName: this.extendName,
        id: this.id
      })
    },
    // 删除
    remove () {
      if (!this.canRemove) {
        return
      }
      this.$emit('remove', {
        url: this.url,
        fileName: this.fileName,
        extendName: this.extendName,
        id: this.id
      })
    },
  }
}
</script>
<style lang="less" scoped>
  .kye-preview-file-item {
    position: relative;
    font-size: 12px;
    margin-right: 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    width: 180px;
    height: 28px;
    border: 1px solid var(--g-border-color);
    background-color: var(--g-bg-gray);
    &-info {
      display: flex;
      align-items: center;
      flex: 1;
      padding-right: 8px;
      color: var(--g-color-text);
      overflow: hidden;
      &.is-preview {
        cursor: pointer;
        color: var(--g-color-primary);
        &:hover {
          color: var(--g-color-primary-hover);
        }
        &:active {
          color: var(--g-color-primary-active);
        }
      }
      &-img {
        width: 12px;
        height: 12px;
        margin-right: 5px;
      }
      &-name {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &-tools {
      color: var(--g-color-primary);
      display: flex;
      align-items: center;
      &-icon {
        display: flex;
        align-items: center;
        padding: 4px;
        border-radius: var(--g-border-radius);
        width: 20px;
        height: 20px;
        cursor: pointer;
        img {
          width: 100%;
        }
        &.is-remove {
          img {
            width: 14px;
          }
        }
        &:hover {
          background: rgba(29, 28, 35, 0.04);
        }
        &:active {
          background: rgba(29, 28, 35, 0.08);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-preview/component/file-item.vue